import { SDKWeek } from '@pff-consumer/schema'

export const isNextSeasonUpcoming = (currentGameWeek: SDKWeek | null) => {
  if (!currentGameWeek) {
    return false
  }
  return currentGameWeek.abbreviation === '1' && currentGameWeek.status === 'upcoming'
}
